import React from 'react';

import { Chip, ErrorIcon, makeStyles } from '@gogame/components';
import { ScreenLink } from '@gogame/screens';

import { smartRulesDetailsLink } from 'scenes/SmartRules/navigation';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.error.main,
  },
  icon: {
    color: theme.palette.error.main,
  },
}));
const ErrorOccured = ({ id }) => {
  const classes = useStyles();

  const label = (
    <ScreenLink
      link={smartRulesDetailsLink}
      pathParams={{
        id,
      }}
      color={'error'}
      underline={'none'}
    >
      Error occurred
    </ScreenLink>
  );

  return (
    <Chip
      label={label}
      variant={'outlined'}
      icon={<ErrorIcon />}
      color={'error'}
      classes={classes}
    />
  );
};

export default ErrorOccured;
